import React from 'react';
import moment from 'moment';
import { withLocalize} from 'react-localize-redux';
import BbInput from "../../styling/bbInput";
import BbDatePicker from '../../common/datePicker';
import { connect as connectFormik } from 'formik';

class IdentitySection extends React.Component {
    onDateChange = (day) => {
        if (moment(day, "l", true).isValid())
            this.props.formik.setFieldValue("dob", [moment(day, "l").format("YYYY-MM-DD")]);
        else if(moment(day, "L", true).isValid()) 
            this.props.formik.setFieldValue("dob", [moment(day, "L").format("YYYY-MM-DD")]);
        else if(day === "")
            this.props.formik.setFieldValue("dob", "");
    }

    render() {
        return (
            <>
                {this.renderInputText("ico", "Contact.ICO")}
                {this.renderDateOfBirth()}
                {this.renderInputText("rc", "Search.Common.Pid")}
                {this.renderInputText("fullName", "Search.Cee.Name")}
            </>
        );
    }

    renderInputText(key, label) {
        return (
            <div style={{ flexDirection: "row" }} className="col px-1 date-picker-overlay-reversed-direction">
                <BbInput label={this.props.translate(label)} name={key} type="text" placeholder={{ type: 'column' }} />
            </div>
        );
    }

    renderDateOfBirth() {
        return (
            <div style={{ flexDirection: "row" }} className="col px-1 date-picker-overlay-reversed-direction">
                <BbInput type="custom"
                    label={this.props.translate("Search.Common.BirthDate")}
                    placeholder={{ type: "column" }}
                    custom={<BbDatePicker enableReinitialize
                        afterDateChange={day => this.onDateChange(day)}
                        field={"dob"}
                        value={this.props.formik.values.dob}
                        rightPanel={true}
                        formDateFormat="YYYY-MM-DD"
                        yearsBack={120}
                    />}
                />
            </div>
        );
    }
}

export default withLocalize(connectFormik(IdentitySection))
